import { z } from "zod";

export const InvestmentPlanSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  star: z.number(),
  weight: z.number(),
  minReturn: z.number(),
  maxReturn: z.number(),
  status: z.string(),
  isVisible: z.boolean(),
  isPurchasable: z.boolean(),
  planType: z.enum(["NORMAL", "ZERO", "ACTIVATION"]),
  canBuildNetwork: z.boolean(),
  hasROI: z.boolean(),
  hasPrincipalReturn: z.boolean(),
  includesInMaxLeadCalculation: z.boolean(),
  isWithdrawableInvestment: z.boolean(),
  FixedProfit: z.number().nullable().optional(),
  principalReturnRateMonthly: z.number().nullable(),
  principalReturnStartAt: z.string().datetime().nullable(),
  randomProfit: z.boolean(),
  description: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  userPurchasedCount: z.number().optional(),
  paxgPrice: z.number().nullable().optional(),
  price: z.number().nullable().optional(),
  count: z.number().nullable().optional(),
  disabled: z.boolean().nullable().optional(),
});

export type InvestmentPlanSchemaType = z.infer<typeof InvestmentPlanSchema>;
